import qwest from 'qwest';

import Article from '../models/article.jsx';

let ArticleApi = {
  fav(id) {
    return qwest.get(`/Article/Fav/?id=${id}`).then((xhr, response) => {
      if (response.success) {
        return true;
      }

      throw response;
    });
  },

  unFav(id) {
    return qwest.get(`/Article/UnFav/?id=${id}`).then((xhr, response) => {
      if (response.success) {
        return true;
      }

      throw response;
    });
  },


  getSupportArticles() {
    return qwest.get('/Article/Index/?category=support').then((xhr, response) => {
      if (response.success) {
        return response.data.map(article => Article.fromApiFormat(article));
      }

      throw response;
    });
  },

  getArticles(filter = null, page = 1) {
    return qwest.get('/Article/Index/', {
      filter,
      page,
    }, {dataType: 'post'}).then((xhr, response) => {
      if (response.success) {
        response.data.items = (response.data.items || []).map(article => Article.fromApiFormat(article));
        return response.data;
      }

      throw response;
    });
  },

  getEncyclopediaArticles() {
    return qwest.get('/Article/Index/?category=encyclopedia').then((xhr, response) => {
      if (response.success) {
        return response.data.map(article => Article.fromApiFormat(article));
      }

      throw response;
    });
  },

  searchEncyclopediaArticles(terms, topic, page = 1, videosOnly = false) {
    return qwest.get('/Article/SearchEncyclopedia/', {
      q: terms,
      topic: topic,
      page: page,
      videos: videosOnly ? true : null,
    }, {dataType: 'post'}).then((xhr, response) => {
      if (response.success) {
        response.data.items = (response.data.items || []).map(article => Article.fromApiFormat(article));
        return response.data;
      }

      throw response;
    });
  },

  searchSupportArticles(terms, topic, page = 1) {
    return qwest.get('/Article/SearchSupport/', {q: terms, topic: topic, page: page}, {dataType: 'post'}).then((xhr, response) => {
      if (response.success) {
        response.data.items = (response.data.items || []).map(article => Article.fromApiFormat(article));
        return response.data;
      }

      throw response;
    });
  },

  getArticle(articleSlug) {
    return qwest.get(`/Article/Index/${articleSlug}`).then((xhr, response) => {
      if (response.success) {
        return Article.fromApiFormat(response.data);
      }

      throw response;
    });
  },

  saveArticle(article) {
    return qwest.post(`/Article/Index/${article.slug}`, article.toApiFormat()).then((xhr, response) => {
      if (response.success) {
        return Article.fromApiFormat(response.data);
      }

      throw response;
    });
  },

  createArticle(article) {
    return qwest.post('/Article/Index', article.toApiFormat()).then((xhr, response) => {
      if (response.success) {
        return Article.fromApiFormat(response.data);
      }

      throw response;
    });
  },

  getEncyclopediaTopics() {
    return qwest.get('/Article/EncyclopediaTopics').then((xhr, response) => {
      if (response.success) {
        return response.data;
      }

      throw response;
    });
  },

  getSupportTopics() {
    return qwest.get('/Article/SupportTopics').then((xhr, response) => {
      if (response.success) {
        return response.data;
      }

      throw response;
    });
  },
};

export default ArticleApi;
